import { render, staticRenderFns } from "./indications.vue?vue&type=template&id=4c46fa62&lang=pug&"
import script from "./indications.vue?vue&type=script&lang=js&"
export * from "./indications.vue?vue&type=script&lang=js&"
import style0 from "./indications.vue?vue&type=style&index=0&id=4c46fa62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports